import { supabase } from "@/lib/supabase";

export const MEDIA_BUCKET = "rkc-media";

function sanitizeFileName(name: string): string {
  const dotIndex = name.lastIndexOf(".");
  const base = dotIndex > 0 ? name.slice(0, dotIndex) : name;
  const ext = dotIndex > 0 ? name.slice(dotIndex + 1) : "";
  const cleanBase = base
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/^-+|-+$/g, "")
    .slice(0, 48) || "archivo";
  const cleanExt = ext.toLowerCase().replace(/[^a-z0-9]/g, "").slice(0, 8);
  return cleanExt ? `${cleanBase}.${cleanExt}` : cleanBase;
}

interface UploadResult {
  url: string | null;
  error: string | null;
}

/**
 * Uploads a file to Supabase Storage and returns its public URL.
 * Folder names must use only lowercase letters, numbers, underscores or hyphens.
 */
export async function uploadMedia(file: File, folder: string): Promise<UploadResult> {
  if (!file) return { url: null, error: "No se seleccionó ningún archivo." };

  const maxBytes = 5 * 1024 * 1024;
  if (file.size > maxBytes) {
    return { url: null, error: "La imagen supera el límite de 5 MB." };
  }

  const safeFolder = folder
    .toLowerCase()
    .replace(/[^a-z0-9_-]+/g, "-")
    .replace(/^-+|-+$/g, "");
  const path = `${safeFolder}/${Date.now()}-${sanitizeFileName(file.name)}`;

  const { error } = await supabase.storage.from(MEDIA_BUCKET).upload(path, file, {
    cacheControl: "3600",
    upsert: false,
    contentType: file.type || undefined,
  });

  if (error) {
    return { url: null, error: "No se pudo subir la imagen. Intenta de nuevo." };
  }

  const { data } = supabase.storage.from(MEDIA_BUCKET).getPublicUrl(path);
  return { url: data.publicUrl, error: null };
}